import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, MessageCircle } from "lucide-react";
import Logo from "./Logo";
import { BUSINESS, telLink, mailLink, waLink } from "@/data/business";
import { CATEGORIES } from "@/data/destinations";

export default function Footer() {
  return (
    <footer id="contact" className="border-t border-gold/20 bg-coal/50" data-testid="site-footer">
      <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-4">
        <div className="flex flex-col gap-4">
          <Logo />
          <p className="text-sm leading-relaxed text-mist">
            Premium Uttarakhand taxi journeys in a Maruti Suzuki Ertiga — Char Dham Yatra, hill stations, lakes, wildlife and treks, driven by locals who know every bend.
          </p>
          <a href={BUSINESS.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="inline-flex w-fit items-center gap-2 text-sm text-gold hover:text-gold-light">
            <Instagram size={16} /> {BUSINESS.instagram}
          </a>
        </div>
        <div>
          <h3 className="eyebrow mb-4">Explore</h3>
          <ul className="flex flex-col gap-2.5 text-sm text-mist">
            {CATEGORIES.map((c) => (
              <li key={c.id}>
                <Link to={`/explore?category=${c.id}`} className="transition-colors hover:text-gold">{c.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="eyebrow mb-4">Popular Trips</h3>
          <ul className="flex flex-col gap-2.5 text-sm text-mist">
            <li><Link to="/destination/kedarnath" className="hover:text-gold">Kedarnath Yatra</Link></li>
            <li><Link to="/destination/badrinath" className="hover:text-gold">Badrinath Darshan</Link></li>
            <li><Link to="/destination/mussoorie" className="hover:text-gold">Mussoorie Weekends</Link></li>
            <li><Link to="/destination/nainital" className="hover:text-gold">Nainital Lakes</Link></li>
            <li><Link to="/char-dham" className="hover:text-gold">Char Dham Yatra Planning</Link></li>
            <li><Link to="/weekend-trips" className="hover:text-gold">Weekend Itineraries</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="eyebrow mb-4">Talk to Us</h3>
          <ul className="flex flex-col gap-3 text-sm text-mist">
            <li>
              <a href={telLink(BUSINESS.phoneIndiaRaw)} data-testid="footer-phone-india" className="flex items-center gap-2 hover:text-gold">
                <Phone size={15} className="text-gold" /> India: {BUSINESS.phoneIndia}
              </a>
            </li>
            <li>
              <a href={telLink(BUSINESS.phoneIntlRaw)} data-testid="footer-phone-intl" className="flex items-center gap-2 hover:text-gold">
                <Phone size={15} className="text-gold" /> International: {BUSINESS.phoneIntl}
              </a>
            </li>
            <li>
              <a href={waLink("Hello Tingadya Travels! I want to plan a Uttarakhand trip.")} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2 hover:text-gold">
                <MessageCircle size={15} className="text-gold" /> WhatsApp — tap to chat
              </a>
            </li>
            <li>
              <a href={mailLink()} data-testid="footer-email" className="flex items-center gap-2 break-all hover:text-gold">
                <Mail size={15} className="text-gold shrink-0" /> {BUSINESS.email}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6">
        <p className="container-x text-center text-xs text-slategray">
          © {new Date().getFullYear()} {BUSINESS.name} · {BUSINESS.tagline} · Uttarakhand, India
        </p>
      </div>
    </footer>
  );
}
